import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About.vue'
import Feedback from '../views/Feedback.vue'
import AddEntry from '../views/AddEntry.vue'
import MyListings from '../views/MyListings.vue'
import Signin from '../views/Signin.vue'
import ResetPassword from '../views/ResetPassword.vue'
import {firebase} from '@/firebaseInit.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landing',
    component: About
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/signin',
    name: 'signin',
    component: Signin
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback
  },
  {
    path: '/entry/:id',
    name: 'entry',
    meta: { requiresAuth: true },
    component: AddEntry
  },
  {
    path: '/entry/',
    name: 'addentry',
    meta: { requiresAuth: true },
    component: AddEntry
  },
  {
    path: '/listings',
    name: 'MyListings',
    component: MyListings
  },
  {
    path: '/map',
    name: 'map',
    // app.vue always loads the map in the background, so this route is just a placeholder so that view knows to show it
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !await firebase.getCurrentUser()){
    next({ name: 'signin', query: { dest: to.name } });
  }else{
    next();
  }
});

const unsubscribe = firebase.auth().onAuthStateChanged(user => {
  unsubscribe();
  if (!user) return;
  if (router.currentRoute.name != 'landing') return;
  // we assume authenticatd users know about the site already and want to go straight to the map
  router.replace({name: 'map'})
});

export default router